import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { FatipOidcAuthService } from '../auth/fatip-oidc.service';
import { BreakGlassService } from '../auth/break-glass.service';

/**
 * 0.58.1 / 0.61.11 — Welcome-Gate-Guard (Strict-Mode).
 *
 * Verhindert dass geschützte modules/*-Routes per direkt-getipptem
 * URL umgangen werden. Logik (0.61.11 strict, PO-Entscheidung
 * 2026-05-03):
 *
 *   1. Authentifiziert (OIDC oder Break-Glass) → durchlassen
 *   2. Alles andere → redirect zu /welcome
 *
 * Hintergrund: bis 0.61.10 gab es einen sessionStorage-Flag
 * `fap.welcome_gate_passed` der durch einen "öffentliche Inhalte
 * ansehen"-Button im Welcome-Gate gesetzt wurde. Damit konnte ein
 * Anonymer alle Modul-Tiles tab-lifetime-lang erreichen ohne Login.
 * Für ein Pilot-Produkt mit echten Bürger-Daten ist das zu locker —
 * Modul-Betreten erfordert jetzt zwingend eine Identität. Tile-
 * Discovery für Stakeholder läuft weiterhin über die Marketing-
 * Pages (/spotlight — vormals /why, seit 0.62.93 BUG-008 #13 #2 —,
 * /voucher, /login) die im Gate verlinkt sind.
 *
 * Konstante WELCOME_GATE_PASSED_KEY ist entfernt (kein Konsument).
 */

export const welcomeGateGuard: CanActivateFn = async (_route, state) => {
  const oidc = inject(FatipOidcAuthService);
  const bg = inject(BreakGlassService);
  const router = inject(Router);

  if (oidc.authenticated() || bg.isActive()) return true;

  // 0.70.1 Auth-Flash-Fix (Pilot-Befund 2026-07-22): beim Hard-Refresh ist
  // authenticated() initial false, der Bootstrap laeuft noch. Statt sofort
  // zu /welcome umzuleiten (Login-Gate blitzt fuer ein paar Frames auf,
  // danach holt der returnUrl-Mechanismus die Ansicht zurueck), wartet der
  // Guard auf das Bootstrap-Ende. 3s-Deckel: ein nicht erreichbares
  // Backend darf die Navigation nicht blockieren, danach gilt der
  // aktuelle Zustand (Redirect ist dann die ehrliche Antwort).
  await Promise.race([
    oidc.bootstrapDone,
    new Promise<void>((resolve) => setTimeout(resolve, 3000)),
  ]);

  if (oidc.authenticated() || bg.isActive()) return true;

  // 0.61.32.1 — Original-URL als returnUrl-Query-Param an /welcome
  // durchschleifen, Welcome-Gate navigiert nach Auth dorthin (Whitelist
  // auf /modules-Pfade gegen Open-Redirect).
  return router.createUrlTree(['/welcome'], {
    queryParams: { returnUrl: state.url },
  });
};
